import signInModalHtml from "./sign-in-modal.html";

export default class SignInModal{

    constructor(closeOnClickOut = false) {
        $("body").append(signInModalHtml);
        this.modal = $("#signInModal");
        this.title = this.modal.find(".modal-title");
        if (closeOnClickOut){
            this.modal.removeAttr("data-backdrop");
        }
        else{
            this.modal.find(".modal-close-button").remove();
        }
    }

    show(title){
        const self = this;
        self.title.text(title);
        self.modal.modal("show");
    }

    hide(){
        const self = this;
        self.modal.modal("hide");
    }
}